import React from 'react';
import { Outlet } from 'react-router-dom';

const NotFoundLayout: React.FC = () => {
  return <div className='form-auth w-100 m-auto'><Outlet /></div>; // No <Router> here
};

export default NotFoundLayout;
